import auth from '@/services/auth'

const version = {
  get: async function () {
    try {
      const resp = await auth.sendWithApiKey({
        method: 'get',
        url: '/v1/version'
      })
      return resp.data
    } catch (err) {
      return Promise.reject(err)
    }
  }
}

export default version
